import { render, staticRenderFns } from "./PbDashboardColumn.vue?vue&type=template&id=5cf3145e&scoped=true&"
import script from "./PbDashboardColumn.vue?vue&type=script&lang=js&"
export * from "./PbDashboardColumn.vue?vue&type=script&lang=js&"
import style0 from "./PbDashboardColumn.vue?vue&type=style&index=0&id=5cf3145e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf3145e",
  null
  
)

export default component.exports